
import{observer,ComponentView,Preact,h,state,action,Router,Link,LinkProps,Cls,Media,JSX,m,Keyframes, Utils,Head} from "@websites/website_compiler/Client";
import {AEComponentViewProps,AEComponentView} from "../stores/ui";
import {CompanyData} from "../misc";
import * as C from "./BaseCss";
import * as Css from "./MiscCss"
import * as Icons from "./Icons";

export type divProps = JSX.IntrinsicElements["div"];
export type inputProps = JSX.IntrinsicElements["input"];
export type buttonProps = JSX.IntrinsicElements["button"];
export type aProps = JSX.IntrinsicElements["a"];
export type liProps = JSX.IntrinsicElements["li"];
export type labelProps = JSX.IntrinsicElements["label"];
export type textAreaProps = JSX.IntrinsicElements["textarea"];
export type imgProps = JSX.IntrinsicElements["img"];
export type imageProps = JSX.IntrinsicElements["image"];

export function FacebookIcon(args:{class?:string,color?:string,stroke?:boolean}){
    if(args.stroke){
        return <svg xmlns="http://www.w3.org/2000/svg"  class={args.class} viewBox="0 0 50 50" width="50px" height="50px"><path  style={{fill: args.color || "red"}} d="M 25 3 C 12.861562 3 3 12.861562 3 25 C 3 36.019135 11.127533 45.138355 21.712891 46.728516 L 22.861328 46.902344 L 22.861328 29.566406 L 17.664062 29.566406 L 17.664062 26.046875 L 22.861328 26.046875 L 22.861328 21.373047 C 22.861328 18.494965 23.551973 16.599417 24.695312 15.410156 C 25.838652 14.220896 27.528004 13.621094 29.878906 13.621094 C 31.758714 13.621094 32.490022 13.734993 33.185547 13.820312 L 33.185547 16.701172 L 30.738281 16.701172 C 29.349697 16.701172 28.210449 17.475903 27.619141 18.507812 C 27.027832 19.539724 26.84375 20.771816 26.84375 22.027344 L 26.84375 26.044922 L 32.966797 26.044922 L 32.421875 29.564453 L 26.84375 29.564453 L 26.84375 46.929688 L 27.978516 46.775391 C 38.71434 45.319366 47 36.126845 47 25 C 47 12.861562 37.138438 3 25 3 z M 25 5 C 36.057562 5 45 13.942438 45 25 C 45 34.729791 38.035799 42.731796 28.84375 44.533203 L 28.84375 31.564453 L 34.136719 31.564453 L 35.298828 24.044922 L 28.84375 24.044922 L 28.84375 22.027344 C 28.84375 20.989871 29.033574 20.060293 29.353516 19.501953 C 29.673457 18.943614 29.981865 18.701172 30.738281 18.701172 L 35.185547 18.701172 L 35.185547 12.009766 L 34.318359 11.892578 C 33.718567 11.811418 32.349197 11.621094 29.878906 11.621094 C 27.175808 11.621094 24.855567 12.357448 23.253906 14.023438 C 21.652246 15.689426 20.861328 18.170128 20.861328 21.373047 L 20.861328 24.046875 L 15.664062 24.046875 L 15.664062 31.566406 L 20.861328 31.566406 L 20.861328 44.470703 C 11.816995 42.554813 5 34.624447 5 25 C 5 13.942438 13.942438 5 25 5 z"/></svg>
    }
    return <svg width="10" height="10" class={args.class} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 5C10 2.24 7.76 0 5 0C2.24 0 0 2.24 0 5C0 7.42 1.72 9.435 4 9.9V6.5H3V5H4V3.75C4 2.785 4.785 2 5.75 2H7V3.5H6C5.725 3.5 5.5 3.725 5.5 4V5H7V6.5H5.5V9.975C8.025 9.725 10 7.595 10 5Z" fill={args.color}/>
    </svg>
}
export function InstagramIcon(args:{class?:string,color?:string,stroke?:boolean}){
    console.log("args",args.stroke)
    if(args.stroke){
        return <svg xmlns="http://www.w3.org/2000/svg"    class={args.class} viewBox="0 0 50 50" width="50px" height="50px"><path  style={{fill: args.color || "red"}} d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"/></svg>
    }
    return <svg xmlns="http://www.w3.org/2000/svg"  class={args.class} viewBox="0 0 30 30" width="30px" height="30px" style={{fill: args.color || "red"}}>    <path   style={{fill:  args.color || "red"}} d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z"/></svg>
    
}

export function PageMargins(props:{large?:boolean,small?:boolean,fillToSideBar?:boolean,children?:any,containerStyles?:any,innerCls?:string}){

    if(props.fillToSideBar){
        var maxWidth = Css.pageMarginsInnerContainerFillToSideBar;
        
    }else if(props.large){
        var maxWidth =  Css.pageMarginsLarge;
    }else if(props.small){
        var maxWidth =  Css.pageMarginsSmall;
    }


    return (
        <div class={m(Css.pageMarginsContainer,props.fillToSideBar ? Css.pageMarginsFillToSideBar : "")} style={props.containerStyles}>
            <div class={m(Css.pageMarginsInnerContainer,maxWidth,props.innerCls)} >
                
                { props.children }
               
            </div>
        </div>
    )
}
interface SolidBtnProps extends LinkProps { outline?:boolean, white?:boolean,yellow?:boolean,black?:boolean}
export function SolidBtn(props:SolidBtnProps){
    
    if(props.outline){
        var cls = Css.outlineBtn;
        if(props.white){
            cls = cls + " " + Css.outlineBtnWhite
        }if(props.yellow){
            cls = cls + " " + Css.outlineYellowBtn
        
        }else{

        }
    }else{
        var cls = Css.primaryBtn;
        if(props.white){
            cls = cls + " " + Css.primaryBtnWhite
        }else if(props.yellow){
            cls = cls + " " + Css.primaryBtnYellow
        }else if(props.black){
            cls = cls + " " + Css.primaryBtnBlack
        }else{

        }
        
    }
    if(props.class){
        cls = cls + " " + props.class
    }
    
    return <Link  {...props} class={cls}> {props.children} </Link>
}
export function VerticalSpacer(){
    return <div class={Css.pageBottomPaddingContainer}></div>
}
export function PageTitle(props:{title:string,subTitle:string,addAnimation ? :boolean}){
    return <div class={Css.pageTitleContainer}>
        <h1 class={m(Css.pageTitleMain,props.addAnimation ? Css.pageTitleMainAnimation : null)}>{props.title}</h1>
        <h2 class={m(Css.pageTitleSub,props.addAnimation ? Css.pageTitleSubAnimation : null)}>{props.subTitle}</h2>
    </div>
}

export class HeaderLeftProps{
}
export class HeaderLeft extends AEComponentView<HeaderLeftProps>{
    onMoreClick = () =>{
        this.ui.toggleSidePanel();
    }
    render(){
        if(this.props.children){
            var children = this.props.children
        }else{
            var children = <button title={"Navigation Sidepanel Button"} class={Css.headerLeftMoreBtn} onClick={this.onMoreClick}>
                <Icons.More_HLines class={C.icon20px}></Icons.More_HLines>
            </button>
        }
        return <div class={Css.headerLeft}>
            {children}
        </div>
    }
}
export class HeaderCenterProps {
}
export class HeaderCenter extends AEComponentView<divProps>{

    render(){
        if(typeof this.props.children == "string" ){
            var children = <h1 class={Css.headerCenterTitle}>{this.props.children}</h1>
        }else if(!this.props.children){
            children = <Preact.Fragment>
                <Icons.Logo_Icon class={C.icon30px}></Icons.Logo_Icon>
                <Icons.Logo_Text class={Css.headerCenterLogoText}></Icons.Logo_Text>
            </Preact.Fragment>
        }
    
        return <div {...this.props} class={m(this.props.class,Css.headerCenter)}>
            {children}
        </div>
    }
}
export function HeaderRight(props:buttonProps){
    return <div class={m(Css.headerRight,C.childM0M10)}>
        {props.children}
    </div>
}
export class HeaderProps{
    transparent?:boolean;
    noSpacer?:boolean;
}
export class Header extends AEComponentView<HeaderProps>{
    @state sticky = false;
    componentDidMount(){
        window.addEventListener("resize",this.computeSticky);
        window.addEventListener("scroll",this.computeSticky);
    }
    componentWillUnmount(){

    }
    computeSticky = (evt) =>{
        if(window.scrollY > 1){
            this.sticky = true;
        }else{
            this.sticky = false;
        }
    }
    render(){
        return (
            <Preact.Fragment>
                <div class={m(Css.headContainer,(this.props.transparent && !this.sticky) ? Css.headTransparent : null)} >
                    {this.props.children}
                </div>

                {!this.props.noSpacer && <div class={Css.headSpacer}></div>}
            </Preact.Fragment>

        )
    }
}

export interface ImgProps extends imgProps{lazy?:boolean}
export function Img(props:ImgProps){
    return <img {...props} data-src={props.lazy ? props.src : null} src={props.lazy ? Utils.EmptyImgSrc : props.src } lazy={null}></img>
}
export interface ImageProps extends imageProps{lazy?:boolean}
export function Image(props:ImageProps){
    return <image {...props} data-href={props.lazy ? props.href : null} href={props.lazy ? Utils.EmptyImgSrc : props.href } lazy={null}></image>
}

export module Footer{
    export class Props{
    }
    
    export class View extends ComponentView<Props>{

        render(){
            return (
                <footer>
                    <div class={Css.footerContainer}>
                        <PageMargins large>
                            <div class={C.columnCenter}>
                                <Icons.Logo_Icon class={Css.footerLogoIcon}></Icons.Logo_Icon>
                                <Icons.Logo_Text class={Css.footerLogoText}></Icons.Logo_Text>
                                {/* <h1 style={{marginTop:"30px",fontWeight:"100"}}>Footer Goes Here</h1> */}
                                {/* <div class={Css.links}>
                                    <Link>Gallery</Link>
                                    <Link>Contact</Link>
                                    <Link>Get Quote</Link>
                                </div>                            */}
                                <div class={Css.footerDetails}>
                                    <Link regLink class={m(Css.footerContactRow,C.childM0M10)} href={"tel: " + CompanyData.phoneNumber}>
                                        <Icons.Phone class={C.icon25px}></Icons.Phone>
                                        <div>{CompanyData.phoneNumber}</div>
                                    </Link>
                                    <div class={m(Css.footerContactRow,C.childM0M10)}>
                                        <Icons.Map_With_Pin class={C.icon25px}></Icons.Map_With_Pin>
                                        <div>{CompanyData.area}</div>
                                    </div>
                                    <a  href={"mailto: " + CompanyData.email} class={m(Css.footerContactRow,C.childM0M10)}>
                                        <Icons.Email class={C.icon25px}></Icons.Email>
                                        <div>{CompanyData.email}</div>
                                    </a>
                                    <a target="_blank" href={CompanyData.facebookUrl} class={m(Css.footerContactRow,C.childM0M10)}>
                                        <FacebookIcon stroke class={C.icon25px} color={C.primaryIconColor}></FacebookIcon>
                                        <span>Facebook</span>
                                    </a>
                                    <a target="_blank" href={CompanyData.instagramUrl}class={m(Css.footerContactRow,C.childM0M10)}>
                                        <InstagramIcon stroke class={C.icon25px} color={C.primaryIconColor}></InstagramIcon>
                                        <span>Instagram</span>
                                    </a>
                                </div>
                                    {/* {!this.props.isQuotePage && <SolidBtn outline white class={Css.footerBtn}  href="/quote">Get Quote</SolidBtn>} */}
                                    {/* {<SolidBtn outline white class={Css.footerBtn} href="/contact">Contact</SolidBtn>} */}

                            </div>
                        </PageMargins>

                            
                    </div>
                </footer>
            )
        }
    }
  
}
export module SquareGrid{
    export class Props{
        class?:string;

    }
    export class View extends ComponentView<Props>{

        render(){

            return (
                <div class={m(Css.SquareGridGrid,this.props.class)}>
                    {this.props.children}
                </div>
            )
        }
    }
 

}

export class AppProps {
    title?:string
    description?:string
    headElements?:any
}
// <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBS9muqi_dmj0BjQpXgfOFzYK3oarTRKQs&callback=initMap&libraries=&v=weekly" defer></script>,
/*
            !this.ui.devMode ? <Preact.Fragment>
            <script async src="https://www.googletagmanager.com/gtag/js?id=UA-158631878-1"></script>
            <script>
                {`window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                
                gtag('config', 'UA-158631878-1');`}
            </script>
        </Preact.Fragment> : <Preact.Fragment></Preact.Fragment>,

*/
@observer export class App extends AEComponentView<AppProps>{
    render(){
        let gtmHead;
        let gtmBody;
        console.log("this.ui.devMode",this.ui.devMode)
        if(!this.ui.devMode){
            gtmHead = <Preact.Fragment>
            {/* {`<!-- Google Tag Manager -->`} */}
            <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NML64TZ');`}</script>
            {/* {`<!-- End Google Tag Manager -->`} */}
            </Preact.Fragment>
            gtmBody = <Preact.Fragment>
                {/* {`<!-- Google Tag Manager (noscript) -->`} */}
                <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NML64TZ" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
                {/* {`<!-- End Google Tag Manager (noscript) -->`} */}
            </Preact.Fragment>
        }
        const head = Head(
            <Preact.Fragment>
                <meta charset="UTF-8"></meta>
                <title>{this.props.title || "Aquatic Edge"}</title>
                {gtmHead}
                <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
                <meta name="theme-color" content={"#142840"} />
                <meta name="description" content={this.props.description}></meta>
                <meta name="og:title" content={this.props.title  || "Aquatic Edge"}></meta>
                <meta name="og:description" content={this.props.description}></meta>
                <meta property="og:image" content="https://www.aquaticedge.ca/assets/misc/socialcard.jpg"></meta>
                <link rel="preconnect" href="https://fonts.gstatic.com"></link>
                <link rel="shortcut icon" href="/assets/favicons/favicon.ico"></link>
                <link rel="icon" type="image/png" sizes="16x16" href="/assets/favicons/favicon-16x16.png"></link>
                <link rel="icon" type="image/png" sizes="32x32" href="/assets/favicons/favicon-32x32.png"></link>
                <link rel="icon" type="image/png" sizes="48x48" href="/assets/favicons/favicon-48x48.png"></link>

                <style>
                    {`

                        /* latin */
                        @font-face {
                            font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 300;
                            font-display: swap;
                            src: url(https://fonts.gstatic.com/s/montserrat/v15/JTURjIg1_i6t8kCHKm45_cJD3gnD_g.woff2) format('woff2');
                            unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                        }

                        /* latin */
                        @font-face {
                        font-family: 'Montserrat';
                        font-style: normal;
                        font-weight: 400;
                        font-display: swap;
                        src: url(https://fonts.gstatic.com/s/montserrat/v15/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2) format('woff2');
                        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                        }


                        /* latin */
                        @font-face {
                        font-family: 'Montserrat';
                        font-style: normal;
                        font-weight: 500;
                        font-display: swap;
                        src: url(https://fonts.gstatic.com/s/montserrat/v15/JTURjIg1_i6t8kCHKm45_ZpC3gnD_g.woff2) format('woff2');
                        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                        }
                        /* latin */
                        @font-face {
                            font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 700;
                            font-display: swap;
                            src: url(https://fonts.gstatic.com/s/montserrat/v15/JTURjIg1_i6t8kCHKm45_dJE3gnD_g.woff2) format('woff2');
                            unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                        }
                        /* latin */
                        @font-face {
                            font-family: 'Patrick Hand';
                            font-style: normal;
                            font-weight: 400;
                            font-display: swap;
                            src: url(https://fonts.gstatic.com/s/patrickhand/v14/LDI1apSQOAYtSuYWp8ZhfYe8XsLL.woff2) format('woff2');
                            unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                        }

                        `}

                </style>
                <style>
                    {
                    `.testsss{
                        color:red;
                    }`
                    }
                </style>
                <link rel="stylesheet" href="/assets/main.css"></link>
                {this.props.headElements}
                
            </Preact.Fragment>
        )
        return (
            <Preact.Fragment>
                {head}
                {gtmBody}
                {this.props.children}
            </Preact.Fragment>
        )
    }
}



export function Spinner(){
    return  <div class={this.props.large ? Css.spinnerContainerLarge : Css.spinnerContainer}></div>
}


